import { Fancybox } from "@fancyapps/ui/dist/fancybox/fancybox.js";

document.addEventListener("DOMContentLoaded", function () {
    Fancybox.bind("[data-fancybox]", {});
});
